import React from 'react';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import { ComposedChart,Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import { setCurrencyFormat } from '../../../../utils/helpers';

export const CustomTooltip = (props) => {
    // eslint-disable-next-line react/prop-types
    const { active, payload } = props;
    // we don't need to check payload[0] as there's a better prop for this purpose
    // eslint-disable-next-line react/prop-types
    if (!active) {        
        // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
        return null
    }
// eslint-disable-next-line react/prop-types
    if (payload === null) {
        return null
    }
    // mutating props directly is against react's conventions
    // so we create a new payload with the name and value fields set to what we want
    // eslint-disable-next-line react/prop-types
    const data = payload[0]?.payload;

    let newPayload = { ...payload }
    if (data) {
        newPayload = Object.keys(data).map((key) => {          

            if (key === 'day') {
                 return {
                     name: 'Date',
                     value: data?.day,
                 }
            }
            if (key === 'Sales') {
                return {
                    name: 'Sales',
                    value: setCurrencyFormat(data?.Sales, true),
                }
            }

            if (key === 'AdvSales') {
                return {
                    name: 'Adv Sales',
                    value: setCurrencyFormat(data?.AdvSales, true),
                }
            }            

            if (key === 'Spend') {
                return {
                    name: 'Spend',
                    value: setCurrencyFormat(data?.Spend, true),
                }
            }

            return {
                name: 'ACOS',
                value: `${data?.ACOS} %`,
            }

        })
    }

    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
};

const AdvSalesChart = ({ dir, height, dataToPlot, index }) => {
    const thisMonthData = {};
    return (
        
        <ResponsiveContainer width="100%" height={height}>
            <ComposedChart
                width={500}
                height={300}
                data={dataToPlot}
                margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                }}
            >
                <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
                <XAxis dataKey="day" reversed={dir === 'rtl'} />
                <YAxis type="number" />
                <Tooltip content={<CustomTooltip/>} 
                                />
                <Legend />
                <Line dot={false} type="monotone" dataKey={'AdvSales'.toString()} 
                stroke='#0080ff' strokeWidth={2} />     
                <Area type="monotone" dataKey="Sales" fill="#999900" stroke="#999900" />  
                <Line dot={false} type="monotone" dataKey={'Spend'.toString()} 
                stroke='#FF0000' strokeWidth={2} />

            </ComposedChart>
        </ResponsiveContainer>
    )
}

AdvSalesChart.propTypes = {
    dir: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    dataToPlot: PropTypes.arrayOf({}).isRequired,
    index: PropTypes.number,
    // eslint-disable-next-line react/forbid-prop-types
};

AdvSalesChart.defaultProps = {
    index: 0
  }

export default React.memo(AdvSalesChart);